import { render, staticRenderFns } from "./is-loader.vue?vue&type=template&id=831dbbb6&scoped=true&"
import script from "./is-loader.vue?vue&type=script&lang=js&"
export * from "./is-loader.vue?vue&type=script&lang=js&"
import style0 from "./is-loader.vue?vue&type=style&index=0&id=831dbbb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831dbbb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VProgressCircular,VRow})
